module.exports = __webpack_public_path__ + "img/logo-white.c2c29022.svg";